import { render } from "./AppSubmenu.vue?vue&type=template&id=56f175da"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__